/* NM — Built for the Wild · interacciones */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.nm-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('nm-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initProducto(root) {
    var datos = root.querySelector('[data-nm-variantes]');
    if (!datos) return;
    var ocultas = datos.getAttribute('data-nm-ocultas') || '';
    var variantes = JSON.parse(datos.textContent).filter(function (v) { return ocultas.indexOf(',' + v.id + ',') === -1; });
    var moneda = root.getAttribute('data-moneda-formato') || '${{amount}}';
    var form = root.querySelector('form.nm-form');
    var inputId = form ? form.querySelector('input[name="id"]') : null;
    var boton = root.querySelector('[data-nm-boton]');
    var botonTexto = boton ? boton.getAttribute('data-texto') : '';
    var botonAgotado = boton ? boton.getAttribute('data-agotado') : '';
    var precioEl = root.querySelector('[data-nm-precio]');
    var tachadoEl = root.querySelector('[data-nm-tachado]');
    var ahorroEl = root.querySelector('[data-nm-ahorro]');
    var stockEl = root.querySelector('[data-nm-stock]');
    var barraPrecio = document.querySelector('[data-nm-barra-precio]');
    var barraBoton = document.querySelector('[data-nm-barra-boton]');

    function formatear(centimos) {
      var n = (centimos / 100);
      return moneda
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toLocaleString('en-US'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    }

    function seleccion() {
      var opts = [];
      root.querySelectorAll('[data-nm-opcion]').forEach(function (grupo) {
        var marcado = grupo.querySelector('input:checked');
        opts.push(marcado ? marcado.value : null);
        var etiqueta = grupo.querySelector('[data-nm-opcion-valor]');
        if (etiqueta && marcado) etiqueta.textContent = marcado.value;
      });
      return opts;
    }

    function marcarAgotadas(opts) {
      var grupos = root.querySelectorAll('[data-nm-opcion]');
      grupos.forEach(function (grupo, idx) {
        grupo.querySelectorAll('input').forEach(function (input) {
          var prueba = opts.slice();
          prueba[idx] = input.value;
          var hay = variantes.some(function (v) {
            return v.available && v.options.every(function (o, i) { return prueba[i] === null || o === prueba[i]; });
          });
          var pastilla = input.nextElementSibling;
          if (pastilla) pastilla.classList.toggle('is-agotada', !hay);
        });
      });
    }

    function actualizar() {
      var opts = seleccion();
      var v = variantes.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      marcarAgotadas(opts);
      if (!v) {
        if (boton) { boton.disabled = true; boton.querySelector('span').textContent = botonAgotado; }
        if (barraBoton) barraBoton.disabled = true;
        return;
      }
      if (inputId) inputId.value = v.id;
      if (precioEl) precioEl.textContent = formatear(v.price);
      if (barraPrecio) barraPrecio.textContent = formatear(v.price);
      var hayTachado = !root.querySelector('[data-nm-sin-rebajas]') && v.compare_at_price && v.compare_at_price > v.price;
      if (tachadoEl) { tachadoEl.hidden = !hayTachado; if (hayTachado) tachadoEl.textContent = formatear(v.compare_at_price); }
      if (ahorroEl) {
        ahorroEl.hidden = !hayTachado;
        if (hayTachado) ahorroEl.textContent = ahorroEl.getAttribute('data-plantilla').replace('[%]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
      }
      if (boton) {
        boton.disabled = !v.available;
        boton.querySelector('span').textContent = v.available ? botonTexto : botonAgotado;
      }
      if (barraBoton) barraBoton.disabled = !v.available;
      if (stockEl) {
        stockEl.classList.toggle('is-agotado', !v.available);
        stockEl.textContent = v.available ? stockEl.getAttribute('data-si') : stockEl.getAttribute('data-no');
      }
      if (v.featured_media && root.nmIrAMedia) root.nmIrAMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-nm-opcion] input').forEach(function (input) {
      input.addEventListener('change', actualizar);
    });
    actualizar();

    // Cantidad
    var cantidad = root.querySelector('[data-nm-cantidad]');
    if (cantidad) {
      var campo = cantidad.querySelector('input');
      cantidad.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(campo.value, 10) || 1;
          n = b.getAttribute('data-paso') === '+' ? n + 1 : Math.max(1, n - 1);
          campo.value = n;
        });
      });
    }

    // Barra fija inferior
    var barra = document.querySelector('[data-nm-barra]');
    if (barra && boton) {
      var revisarBarra = function () { barra.classList.toggle('is-visible', boton.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', revisarBarra, { passive: true });
      window.addEventListener('resize', revisarBarra);
      revisarBarra();
      if (barraBoton) barraBoton.addEventListener('click', function () {
        if (form) form.requestSubmit ? form.requestSubmit(boton) : form.submit();
      });
    }

    // Guía de tallas
    var guiaBtn = root.querySelector('[data-nm-abrir-guia]');
    var guia = root.querySelector('[data-nm-guia]');
    if (guiaBtn && guia) {
      guiaBtn.addEventListener('click', function () {
        guia.open = true;
        guia.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  function initGaleria(root) {
    var principal = root.querySelector('[data-nm-principal]');
    var minis = Array.prototype.slice.call(root.querySelectorAll('[data-nm-mini]'));
    if (!principal || !minis.length) return;
    var actual = 0;
    function ir(i) {
      actual = (i + minis.length) % minis.length;
      var m = minis[actual];
      principal.src = m.getAttribute('data-grande');
      principal.alt = m.getAttribute('data-alt') || '';
      minis.forEach(function (x) { x.classList.toggle('is-activa', x === m); });
      m.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    minis.forEach(function (m, i) { m.addEventListener('click', function () { ir(i); }); });
    var prev = root.querySelector('[data-nm-prev]');
    var next = root.querySelector('[data-nm-next]');
    if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
    if (next) next.addEventListener('click', function () { ir(actual + 1); });
    root.nmIrAMedia = function (id) {
      var idx = minis.findIndex(function (m) { return m.getAttribute('data-media-id') === String(id); });
      if (idx > -1) ir(idx);
    };
  }

  // Aviso de cookies conectado a la API de privacidad de Shopify
  function initCookies() {
    var banner = document.querySelector('[data-nm-cookies]');
    if (!banner || banner.dataset.nmListo) return;
    banner.dataset.nmListo = '1';
    var CLAVE = 'nm-cookie-choice';
    var editor = window.Shopify && window.Shopify.designMode;

    function leer() { try { return localStorage.getItem(CLAVE); } catch (e) { return null; } }
    function guardar(v) { try { localStorage.setItem(CLAVE, v); } catch (e) {} }
    function conApi(cb) {
      if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          cb(err ? null : window.Shopify.customerPrivacy);
        });
      } else { cb(null); }
    }
    function decidir(si) {
      var v = { analytics: si, marketing: si, preferences: si, sale_of_data: si };
      conApi(function (cp) { if (cp && cp.setTrackingConsent) cp.setTrackingConsent(v, function () {}); });
      if (!editor) guardar(si ? 'yes' : 'no');
      banner.hidden = true;
    }

    banner.querySelector('[data-nm-cookies-aceptar]').addEventListener('click', function () { decidir(true); });
    banner.querySelector('[data-nm-cookies-rechazar]').addEventListener('click', function () { decidir(false); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#cookie-settings"]');
      if (!a) return;
      e.preventDefault();
      banner.hidden = false;
    });

    if (editor || !leer()) banner.hidden = false;
    // Si el aviso nativo de Shopify está activo, se usa ese y se oculta este para no duplicar
    conApi(function (cp) {
      if (editor) return;
      var nativo = function () { return document.getElementById('shopify-pc__banner') || document.querySelector('[id^="shopify-pc__banner"]'); };
      if ((cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) || nativo()) { banner.hidden = true; return; }
      setTimeout(function () { if (nativo()) banner.hidden = true; }, 2500);
    });
  }

  // Sugerencia de país e idioma según la ubicación (Shopify) y el idioma del navegador
  function initLocalizacion() {
    var caja = document.querySelector('[data-nm-loc]');
    if (!caja || caja.dataset.nmListo) return;
    caja.dataset.nmListo = '1';
    var datos;
    try { datos = JSON.parse(caja.querySelector('[data-nm-loc-datos]').textContent); } catch (e) { return; }
    var TXT = {
      en: ['Detected country: {c}. View the store in {l} with prices in {m}?', 'Switch', 'No thanks'],
      es: ['País detectado: {c}. ¿Ver la tienda en {l} con precios en {m}?', 'Cambiar', 'No, gracias'],
      fr: ['Pays détecté : {c}. Voir la boutique en {l} avec les prix en {m} ?', 'Changer', 'Non merci'],
      de: ['Erkanntes Land: {c}. Shop auf {l} mit Preisen in {m} anzeigen?', 'Wechseln', 'Nein, danke'],
      it: ['Paese rilevato: {c}. Vedere il negozio in {l} con prezzi in {m}?', 'Cambia', 'No, grazie'],
      'pt-PT': ['País detetado: {c}. Ver a loja em {l} com preços em {m}?', 'Mudar', 'Não, obrigado']
    };
    var CLAVE = 'nm-loc-dismiss';
    function idiomaNavegador() {
      var navs = navigator.languages || [navigator.language || 'en'];
      for (var i = 0; i < navs.length; i++) {
        var n = String(navs[i]).toLowerCase(), base = n.split('-')[0];
        for (var j = 0; j < datos.idiomas.length; j++) {
          var iso = datos.idiomas[j].i.toLowerCase();
          if (iso === n || iso.split('-')[0] === base) return datos.idiomas[j].i;
        }
      }
      return datos.idioma;
    }
    fetch('/browsing_context_suggestions.json?country[enabled]=true')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (j) {
        var detectado = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        var pais = detectado && datos.paises[detectado] ? detectado : datos.pais;
        var idioma = idiomaNavegador();
        if (pais === datos.pais && idioma === datos.idioma) return;
        var marca = pais + '|' + idioma;
        try { if (localStorage.getItem(CLAVE) === marca) return; } catch (e) {}
        var t = TXT[idioma] || TXT[idioma.split('-')[0]] || TXT.en;
        var nombreIdioma = (datos.idiomas.filter(function (l) { return l.i === idioma; })[0] || {}).n || idioma;
        var p = datos.paises[pais] || { n: pais, m: '' };
        var nombrePais = p.n;
        try { nombrePais = new Intl.DisplayNames([idioma], { type: 'region' }).of(pais) || p.n; } catch (e) {}
        caja.querySelector('[data-nm-loc-texto]').textContent = t[0].replace('{c}', nombrePais).replace('{l}', nombreIdioma).replace('{m}', p.m);
        var si = caja.querySelector('[data-nm-loc-si]'), no = caja.querySelector('[data-nm-loc-no]');
        si.textContent = t[1]; no.textContent = t[2];
        si.addEventListener('click', function () {
          var f = caja.querySelector('form');
          f.querySelector('[name="country_code"]').value = pais;
          f.querySelector('[name="language_code"]').value = idioma;
          f.submit();
        });
        no.addEventListener('click', function () {
          try { localStorage.setItem(CLAVE, marca); } catch (e) {}
          caja.hidden = true;
        });
        caja.hidden = false;
      });
  }

  // Botón de sugerencias (formulario de contacto de Shopify), textos según idioma de la página
  function initSugerencias() {
    var caja = document.querySelector('[data-nm-sug]');
    if (!caja || caja.dataset.nmListo) return;
    caja.dataset.nmListo = '1';
    var T = {
      es: { boton: 'Sugerencias', titulo: 'Ayúdanos a mejorar', texto: '¿Echas en falta un producto, una talla o algo en la web? Cuéntanoslo: leemos todos los mensajes.', email: 'Email (opcional, para poder responderte)', mensaje: 'Tu sugerencia', enviar: 'Enviar', ok: '¡Gracias! Hemos recibido tu sugerencia.' },
      fr: { boton: 'Suggestions', titulo: 'Aidez-nous à progresser', texto: 'Il vous manque un produit, une taille ou une fonction ? Dites-le-nous : nous lisons chaque message.', email: 'E-mail (facultatif, pour vous répondre)', mensaje: 'Votre suggestion', enviar: 'Envoyer', ok: 'Merci ! Nous avons bien reçu votre suggestion.' },
      de: { boton: 'Vorschläge', titulo: 'Hilf uns, besser zu werden', texto: 'Fehlt dir ein Produkt, eine Größe oder eine Funktion? Sag es uns – wir lesen jede Nachricht.', email: 'E-Mail (optional, damit wir antworten können)', mensaje: 'Dein Vorschlag', enviar: 'Senden', ok: 'Danke! Wir haben deinen Vorschlag erhalten.' },
      it: { boton: 'Suggerimenti', titulo: 'Aiutaci a migliorare', texto: 'Ti manca un prodotto, una taglia o una funzione? Diccelo: leggiamo ogni messaggio.', email: 'Email (facoltativa, per poterti rispondere)', mensaje: 'Il tuo suggerimento', enviar: 'Invia', ok: 'Grazie! Abbiamo ricevuto il tuo suggerimento.' },
      pt: { boton: 'Sugestões', titulo: 'Ajude-nos a melhorar', texto: 'Falta-lhe um produto, um tamanho ou uma funcionalidade? Diga-nos: lemos todas as mensagens.', email: 'Email (opcional, para lhe respondermos)', mensaje: 'A sua sugestão', enviar: 'Enviar', ok: 'Obrigado! Recebemos a sua sugestão.' }
    };
    var t = T[(document.documentElement.lang || 'en').slice(0, 2)];
    if (t) caja.querySelectorAll('[data-nm-t]').forEach(function (el) { var k = el.getAttribute('data-nm-t'); if (t[k]) el.textContent = t[k]; });
    var panel = caja.querySelector('[data-nm-sug-panel]');
    var abrir = function () { panel.hidden = false; var c = panel.querySelector('textarea'); if (c) c.focus(); };
    caja.querySelector('[data-nm-sug-abrir]').addEventListener('click', function () { panel.hidden ? abrir() : (panel.hidden = true); });
    caja.querySelector('[data-nm-sug-cerrar]').addEventListener('click', function () { panel.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') panel.hidden = true; });
    if (caja.querySelector('[data-nm-sug-ok]')) abrir();
  }

  function init() {
    initReveal();
    initSugerencias();
    initCookies();
    initLocalizacion();
    document.querySelectorAll('[data-nm-producto]').forEach(function (root) {
      initGaleria(root);
      initProducto(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
